import { VideoPlayer } from "../atoms/VideoPlayer"

const VideoSample = () => {
    return (
        <VideoPlayer
            src="https://d2u74wp528xaft.cloudfront.net/02_VirtualActivationConfirmation.mpd"
            width={720} // デフォルトは100%で、最大幅は960px
        />
    );
}

export default VideoSample;